const _Subscription = class _Subscription {
  constructor(initialTeardown) {
    this.closed = false;
    this._teardowns = null;
    if (initialTeardown) {
      this.add(initialTeardown);
    }
  }
  unsubscribe() {
    if (this.closed) {
      return;
    }
    this.closed = true;
    const teardowns = this._teardowns;
    this._teardowns = null;
    if (teardowns) {
      let errors = null;
      teardowns.forEach((teardown) => {
        try {
          if (typeof teardown === "function") {
            teardown();
          } else if (teardown && typeof teardown.unsubscribe === "function") {
            teardown.unsubscribe();
          }
        } catch (e) {
          errors = errors || [];
          errors.push(e);
        }
      });
      if (errors) {
        throw new Error(errors.map((e) => e.message).join("\n"));
      }
    }
  }
  add(teardown) {
    if (!teardown) {
      return;
    }
    let teardownToAdd;
    if (typeof teardown === "function") {
      teardownToAdd = teardown;
    } else if (typeof teardown === "object" && teardown !== null && typeof teardown.unsubscribe === "function") {
      teardownToAdd = teardown;
    } else {
      return;
    }
    if (this.closed) {
      if (typeof teardownToAdd === "function") {
        teardownToAdd();
      } else {
        teardownToAdd.unsubscribe();
      }
    } else {
      if (!this._teardowns) {
        this._teardowns = [];
      }
      this._teardowns.push(teardownToAdd);
    }
  }
  remove(teardown) {
    const teardowns = this._teardowns;
    if (!teardowns || !teardown) {
      return;
    }
    const index = teardowns.indexOf(teardown);
    if (index !== -1) {
      teardowns.splice(index, 1);
    }
  }
};
_Subscription.EMPTY = function(empty) {
  empty.closed = true;
  return empty;
}(new _Subscription());
let Subscription = _Subscription;
export {
  Subscription
};
//# sourceMappingURL=Subscription.js.map
